var exports = {
  "M": "x936d19a0--0effb3--top",
  "V": "x936d19a0--0effb3--close",
};

module.exports = exports;
